import { Flex, Icon, Input } from '@chakra-ui/react';
import { SearchSm, ChevronUp, ChevronDown, XClose } from '@kula-ai/icons-core';
import { KText } from '@/ui-library/components/text';

interface DocxSearchBarProps {
  query: string;
  matchCount: number;
  currentIndex: number;
  onQueryChange: (_value: string) => void;
  onNext: () => void;
  onPrev: () => void;
  onClose: () => void;
}

export const DocxSearchBar = ({
  query,
  matchCount,
  currentIndex,
  onQueryChange,
  onNext,
  onPrev,
  onClose,
}: DocxSearchBarProps) => {
  const showCounter = query.length > 0;
  const position = matchCount === 0 ? 0 : currentIndex + 1;

  return (
    <Flex
      align="center"
      gap="6px"
      px="8px"
      h="32px"
      border="1px solid"
      borderColor="secondary-200"
      borderRadius="6px"
      bg="white"
      minW="260px"
    >
      <Icon as={SearchSm} boxSize="16px" color="secondary-500" />
      <Input
        value={query}
        onChange={(event) => onQueryChange(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            if (event.shiftKey) onPrev();
            else onNext();
          } else if (event.key === 'Escape') {
            onClose();
          }
        }}
        placeholder="Search"
        variant="unstyled"
        size="sm"
        autoFocus
        h="20px"
        flex={1}
      />
      {showCounter && (
        <KText size="xs-regular" color="secondary-700">
          {`${position}/${matchCount}`}
        </KText>
      )}
      <Flex
        as="button"
        type="button"
        onClick={onPrev}
        align="center"
        justify="center"
        w="22px"
        h="22px"
        borderRadius="4px"
        _hover={{ bg: 'secondary-50' }}
        cursor="pointer"
        aria-label="Previous match"
      >
        <Icon as={ChevronUp} boxSize="14px" color="secondary-700" />
      </Flex>
      <Flex
        as="button"
        type="button"
        onClick={onNext}
        align="center"
        justify="center"
        w="22px"
        h="22px"
        borderRadius="4px"
        _hover={{ bg: 'secondary-50' }}
        cursor="pointer"
        aria-label="Next match"
      >
        <Icon as={ChevronDown} boxSize="14px" color="secondary-700" />
      </Flex>
      <Flex
        as="button"
        type="button"
        onClick={onClose}
        align="center"
        justify="center"
        w="22px"
        h="22px"
        borderRadius="4px"
        _hover={{ bg: 'secondary-50' }}
        cursor="pointer"
        aria-label="Close search"
      >
        <Icon as={XClose} boxSize="14px" color="secondary-700" />
      </Flex>
    </Flex>
  );
};
